import { Text, Torus, Circle} from '@react-three/drei'
import { useState, useRef, useEffect} from 'react'
import { useFrame } from '@react-three/fiber';
import { MeshBasicMaterial } from 'three';
import { HOARD } from './boardLayout'
import { useControls, button } from 'leva'

const PW = HOARD.PANEL_W, PH = HOARD.PANEL_H
const F = '/Fonts/roc-grotesk-bold.otf'
const LED = '/Fonts/led.ttf'                // Erbos Draco Nova NBP — dot-matrix LED look

export default function Scoreboard(props)
{
    const scoreRef = useRef();
    const [playerScore, setPlayerScore] = useState();
    const [aiScore, setAIScore] = useState()
    const tennisScoring = ((score)=>
    {
        let converted = '-';

        if      (score === 0) converted = '0'
        else if (score === 1) converted = '15'
        else if (score === 2) converted = '30'
        else if (score === 3) converted = '40'
        else if (score === 4) converted = 'AD'
        else if (score  >= 5) converted = 'SET'
        return converted;
    })

    const hideScore = (()=> {
        setShowTheScore(false);
    })

    useEffect(()=>
    {
        let p = tennisScoring(props.pScore)
        let a = tennisScoring(props.aScore)

        if (p != 'SET' && a != 'SET')
        {
            if (p === 'AD' && a === 'AD')
            {
                p='40'
                a = '40'
                props.updateGameStateProperties({aiScore:3, playerScore:3})
            }
            else if (p === 'AD' && a != '40')
            {
                p = 'SET'
                props.updateGameStateProperties({aiScore:0, playerScore:0, playerSets: props.pSets+1})
                //props.setGameWinner('player')
            }
            else if (p != '40' && a === 'AD')
            {
                a = 'SET'
                props.updateGameStateProperties({aiScore:0, playerScore:0, aiSets: props.aSets+1})

                //props.setGameWinner('ai')
            }
        }
        else if (p === 'SET')
        {
            //props.setGameWinner('player')
            props.updateGameStateProperties({aiScore:0, playerScore:0, playerSets: props.pSets+1})
        }
        else if (a === 'SET')
        {
            //props.setGameWinner('ai')
            props.updateGameStateProperties({aiScore:0, playerScore:0, aiSets: props.aSets+1})

        }
        
        setPlayerScore(p)
        setAIScore(a)
        
    },[props.pScore, props.aScore])

    const showLevel = ()=>{
        let r = [];
        let i;
        for (i=0;i<Math.min(props.pSets, 6);i++)
        {
            r.push(<Circle key={i} args={[0.5,10]} position={[-3+i,-3,0]}>
                <meshBasicMaterial color={'orange'}/>
            </Circle>)
        }  
        for (;i<6;i++)
        {
            r.push(<Torus key={i} args={[0.35,0.07,10]} position={[-3+i,-3,0]}>
                    <meshBasicMaterial color={'orange'}/>
                </Torus>)
        } 
        return r; 
    }

    const ctrl = useControls('Scoreboard', {
        nameSize:    { value: 2.3, min: 0.4, max: 4, step: 0.05 },
        scoreSize:   { value: 3.0, min: 0.4, max: 4, step: 0.05 },
        headerSize:  { value: 0.8, min: 0.2, max: 1.5, step: 0.05 },
        fontColor:   '#93b43e',
        innerWidth:  { value: 22.2, min: 8, max: 30, step: 0.2 },
        innerHeight: { value: 5.8, min: 2, max: 12, step: 0.1 },
        headerGap:   { value: 1.35, min: 0, max: 4, step: 0.05 },
        rowSpacing:  { value: 1.75, min: 1, max: 4, step: 0.05 },
        boardHeight: { value: 6.9, min: 3, max: 12, step: 0.1 },
        boardColor:  '#2e764a',
        innerColor:  '#1c452e',
        borderColor: '#1c452e',
        'copy settings': button((get) => {
            const keys = ['nameSize', 'scoreSize', 'headerSize', 'fontColor', 'innerWidth', 'innerHeight', 'headerGap', 'rowSpacing', 'boardHeight', 'boardColor', 'innerColor', 'borderColor']
            const out = {}; keys.forEach((n) => { out[n] = get('Scoreboard.' + n) })
            out.ribbonColor = get('Ad board.ribbonColor')
            const txt = JSON.stringify(out, null, 2)
            try { navigator.clipboard.writeText(txt) } catch (e) {}
            console.log('=== BOARD SETTINGS (paste to Claude) ===\n' + txt)
        }),
    })
    const youY = -0.55 + ctrl.rowSpacing / 2
    const cpuY = -0.55 - ctrl.rowSpacing / 2
    const headerY = youY + ctrl.headerGap

    return props.showScore ? (
        <group ref={scoreRef} position={[0, HOARD.Y, HOARD.PANEL_Z]}>
            {/* frame + board */}
            <mesh position={[0, 0, -0.03]}>
                <planeGeometry args={[PW + 0.9, ctrl.boardHeight + 0.9]} />
                <meshBasicMaterial color={ctrl.borderColor} toneMapped={false} />
            </mesh>
            <mesh>
                <planeGeometry args={[PW, ctrl.boardHeight]} />
                <meshBasicMaterial color={ctrl.boardColor} toneMapped={false} />
            </mesh>

            {/* dark LED score area */}
            <mesh position={[0, -0.35, 0.01]}>
                <planeGeometry args={[ctrl.innerWidth, ctrl.innerHeight]} />
                <meshBasicMaterial color={ctrl.innerColor} toneMapped={false} />
            </mesh>

            {/* column labels */}
            <Text font={F} fontSize={ctrl.headerSize} position={[2.5, headerY, 0.05]} anchorX="center" anchorY="middle">SET<meshBasicMaterial color="#9fd3b4" toneMapped={false} /></Text>
            <Text font={F} fontSize={ctrl.headerSize} position={[7.5, headerY, 0.05]} anchorX="center" anchorY="middle">PTS<meshBasicMaterial color="#9fd3b4" toneMapped={false} /></Text>

            {/* player row — LED font */}
            <Text font={LED} fontSize={ctrl.nameSize} position={[-10, youY, 0.05]} anchorX="left" anchorY="middle">YOU<meshBasicMaterial color={ctrl.fontColor} toneMapped={false} /></Text>
            <Text font={LED} fontSize={ctrl.scoreSize} position={[2.5, youY, 0.05]} anchorX="center" anchorY="middle">{props.pSets < 10 ? '0' + props.pSets : '' + props.pSets}<meshBasicMaterial color={ctrl.fontColor} toneMapped={false} /></Text>
            <Text font={LED} fontSize={ctrl.scoreSize} position={[7.5, youY, 0.05]} anchorX="center" anchorY="middle">{playerScore || '0'}<meshBasicMaterial color={ctrl.fontColor} toneMapped={false} /></Text>

            {/* cpu row — LED font */}
            <Text font={LED} fontSize={ctrl.nameSize} position={[-10, cpuY, 0.05]} anchorX="left" anchorY="middle">CPU<meshBasicMaterial color={ctrl.fontColor} toneMapped={false} /></Text>
            <Text font={LED} fontSize={ctrl.scoreSize} position={[2.5, cpuY, 0.05]} anchorX="center" anchorY="middle">{props.aSets < 10 ? '0' + props.aSets : '' + props.aSets}<meshBasicMaterial color={ctrl.fontColor} toneMapped={false} /></Text>
            <Text font={LED} fontSize={ctrl.scoreSize} position={[7.5, cpuY, 0.05]} anchorX="center" anchorY="middle">{aiScore || '0'}<meshBasicMaterial color={ctrl.fontColor} toneMapped={false} /></Text>
        </group>
    ) : null
}

